import { useCallback, useRef } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

const PRE_MADE_POST_MODULE_VIEW_EVENT_NAME = 'petition_manage_ready_to_share_posts_view_v2_pre_drafted';
const PRE_MADE_POST_MODULE_EVENT_COMMON_PROPERTIES = {
	context: 'petition_dashboard_ready_to_share_post_pre_drafted',
	view_context: 'petition_dashboard_ready_to_share_post_pre_drafted',
};

const MODULE_VIEW_EVENT_NAME = 'petition_manage_ready_to_share_module_view';

type UseViewTrackingParams = {
	selectedTab: string;
};

type UseViewTrackingResult = {
	trackView: (currentPosition: string) => void;
};

export function useViewTracking({ selectedTab }: UseViewTrackingParams): UseViewTrackingResult {
	const track = useTracking();
	const isTrackedRef = useRef(false);
	const isModuleViewTrackedRef = useRef(false);

	// Track module view event (fires first, immediately when visible)
	const trackModuleView = useCallback(
		(currentPosition: string) => {
			if (isModuleViewTrackedRef.current || currentPosition === 'below') {
				return;
			}
			void track(MODULE_VIEW_EVENT_NAME, {
				context: 'petition_dashboard_ready_to_share_post',
				view_context: selectedTab,
			});
			isModuleViewTrackedRef.current = true;
		},
		[track, selectedTab],
	);

	// Track view event (existing event)
	const trackView = useCallback(
		(currentPosition: string) => {
			// Track module view first
			trackModuleView(currentPosition);

			// Then track the existing event
			if (isTrackedRef.current || currentPosition === 'below') {
				return;
			}
			void track(PRE_MADE_POST_MODULE_VIEW_EVENT_NAME, PRE_MADE_POST_MODULE_EVENT_COMMON_PROPERTIES);
			isTrackedRef.current = true;
		},
		[track, trackModuleView],
	);

	return {
		trackView,
	};
}
